function findBundledLineItem(lineItems, productType) {
  return lineItems.find(
    (lineItem) => lineItem.legacyProduct.productType.localeCompare(productType, "en", {
      sensitivity: "base",
      usage: "search"
    }) === 0
  );
}
export {
  findBundledLineItem
};
//# sourceMappingURL=find-bundled-line-item.js.map
